import { api as apiProvider } from '@/core/api/';

export const searchAvailableSpaces = async (model) => {
  return await apiProvider.get('/api/providers/appointmentSpace/search', {
    params: model,
  });
};

export const canCreateSpaceForNextYear = async () => {
  return await apiProvider.get(
    '/api/providers/appointmentSpace/cancreatespacefornextyear'
  );
};

export const getMunicipalities = async (companyId, specialistId) => {
  return await apiProvider.get(
    '/api/providers/appointmentSpace/municipalities',
    { params: { companyId: companyId, specialistId: specialistId } }
  );
};

export const getServiceLocations = async (
  companyId,
  municipalityId,
  specialistId
) => {
  return await apiProvider.get(
    `/api/providers/appointmentSpace/servicelocations/${companyId}/${municipalityId}/${specialistId}`
  );
};

export const getSpecialists = async (companyId, municipalityId, locationId) => {
  return await apiProvider.get(
    `/api/providers/appointmentSpace/specialists/${companyId}/${municipalityId}/${locationId}`
  );
};

export const getCompaniesByLocationId = async (fiscalYear, locationId) => {
  return await apiProvider.get(
    `/api/providers/appointmentSpace/companiesbylocation/${fiscalYear}/${locationId}`
  );
};

export const initAvailableSpacesFilters = async () => {
  return await apiProvider.get('/api/providers/appointmentSpace/initfilters');
};

export const getServiceTypes = async (
  companyId,
  specialistId,
  municipalityId,
  locationId
) => {
  return await apiProvider.get(
    `/api/providers/appointmentSpace/servicetypes/${companyId}/${specialistId}/${municipalityId}/${locationId}`
  );
};

export const getServices = async (
  locationId,
  serviceTypes,
  companyId,
  specialistId,
  municipalityId
) => {
  return await apiProvider.get(
    `/api/providers/appointmentSpace/services/${locationId}/${serviceTypes}/${companyId}/${specialistId}/${municipalityId}`
  );
};

export const getAvailableSpaceCompanies = () =>
  apiProvider.get('/api/providers/appointmentSpace/companies');
export const getAvailableSpaceMunicipalities = (companyId, specialistId) =>
  apiProvider.get('/api/providers/appointmentSpace/municipalities', {
    params: {
      companyId,
      specialistId,
    },
  });

export const insertAvailableSpace = (payload) =>
  apiProvider.post('api/providers/appointmentSpace', payload);
export const updateAvailableSpace = (payload) =>
  apiProvider.put('api/providers/appointmentSpace', payload);

export const getSpecialistServiceLocations = async (
  companyId,
  municipalityId,
  specialistId
) => {
  return await apiProvider.get(
    `/api/providers/appointmentSpace/specialistservicelocations/${companyId}/${municipalityId}/${specialistId}`
  );
};

export const getSpecialistServiceTypes = async (
  companyId,
  specialistId,
  municipalityId,
  locationId
) => {
  return await apiProvider.get(
    `/api/providers/appointmentSpace/specialistservices/${companyId}/${specialistId}/${municipalityId}/${locationId}`
  );
};

export const deleteAvailableSpace = async (clientAppointmentSpaceId) =>
  apiProvider.delete(
    `/api/providers/appointmentSpace/${clientAppointmentSpaceId}`
  );

export const canCreateAvailableSpace = async () =>
  apiProvider.get(`/api/providers/appointmentSpace/cancreateavailablespace/`);
